import { highlightTitleWords } from '@helpers/utils';
import SvgChevronDown from '@img/icons/chevron-right.svg';
import SvgChevron from '@img/icons/ess-chevron.svg';
import UpsellCard from '@stories/Components/Cards/UpsellCard/UpsellCard';
import * as React from 'react';
import S from '../CartOverlay.styles';
const Upsell = (props) => {
    return (React.createElement(S.UpsellContainer, null,
        props.site === 'ess' && (React.createElement(S.BackgroundChevron, null,
            React.createElement(SvgChevron, null))),
        React.createElement(S.UpsellTitle, null,
            React.createElement("span", { dangerouslySetInnerHTML: { __html: highlightTitleWords(props.title) } }),
            React.createElement(SvgChevronDown, null)),
        React.createElement(S.UpsellGrid, null, props.items.map((item) => (React.createElement(UpsellCard, { key: `upsell-${item.id}`, ...item, site: props.site, buttonLabel: props.buttonLabel, showPrice: props.showPrice, currentProductPageId: props.currentProductPageId }))))));
};
export default Upsell;
